import { colors } from '../../colors';
var service = {
  bgColor: colors.white,
  borderColor: colors.overcast,
  bgColorBlade: colors.white,
  carouselDotColor: colors.brightGreen,
  linkColor: colors.pinkishRed,
  cardRadius: '20px',
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default service;